import { Box } from '@chakra-ui/react';
import { COLORS } from '../../root-constants';


interface DividerProps {
  paper?: boolean;
}

const Divider: React.FC<DividerProps> = ({ paper }) => {
  const onPaper = paper ?? true;
  return <Box h="1px" w="100%" bg={onPaper ? COLORS.BG : COLORS.DIVIDER} />;
};

export default Divider;
